import { motion } from "framer-motion";
import { MapPin, Navigation } from "lucide-react";
import { DISTANCES } from "@/lib/constants";

export const Location = () => {
  return (
    <section id="location" className="relative py-24 md:py-32 border-t border-white/5" data-testid="location-section">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="mb-16 md:mb-20 max-w-3xl"
        >
          <div className="text-xs uppercase tracking-[0.4em] text-[#D4AF37] mb-5">Location</div>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-[#F8F6F0] leading-[1.05] tracking-tight">
            @ Nigdi, Pradhikaran,{" "}
            {/* <span className="italic gold-text"> Pune.</span> */}
            <span className="italic bg-gradient-to-r from-[#ffb413] via-[#D4AF37] to-[#ff9900] text-transparent bg-clip-text">
              Pune.
            </span>
          </h2>
        </motion.div>

        <div className="grid lg:grid-cols-12 gap-8 lg:gap-12">
          {/* Map */}
          <motion.div
            initial={{ opacity: 0, scale: 0.96 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
            className="lg:col-span-7 relative aspect-[4/3] lg:aspect-auto lg:min-h-[520px] bg-[#0A0A0B] border border-[#D4AF37]/20 overflow-hidden"
            data-testid="location-map-card"
          >
            {/* Google Maps Iframe */}
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3780.2889740025325!2d73.767391!3d18.651024199999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2b91040705ea1%3A0xb7f8dd529a2f88de!2sPalaash%20Paradise!5e0!3m2!1sen!2sin!4v1781848759405!5m2!1sen!2sin" 
              width="100%"
              height="100%"
              style={{ border: 0, position: "absolute", inset: 0, width: "100%", height: "100%" }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="z-10"
              title="Palaash Paradise location map"
            />

            {/* Overlay gradient for better readability of corner labels */}
            <div className="absolute inset-0 bg-gradient-to-t from-[#050505]/40 via-transparent to-transparent pointer-events-none z-20" />

            {/* Corner labels */}
            <div className="absolute top-5 left-5 text-[10px] uppercase tracking-[0.3em] text-[#A0A0A0] flex items-center gap-2 z-30">
              <Navigation className="w-3 h-3 text-[#D4AF37]" /> Find us here
            </div>
            <div className="absolute bottom-5 right-5 text-[10px] uppercase tracking-[0.3em] text-[#A0A0A0] z-30">
              Google Maps
            </div>
          </motion.div>

          {/* Distances */}
          <motion.div
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-80px" }}
            variants={{ show: { transition: { staggerChildren: 0.06 } } }}
            className="lg:col-span-5"
          >
            <div className="text-xs uppercase tracking-[0.4em] text-[#D4AF37] mb-6">Key Distance</div>
            <ul className="divide-y divide-white/5">
              {DISTANCES.map((d) => (
                <motion.li
                  key={d.place}
                  variants={{
                    hidden: { opacity: 0, x: 20 },
                    show: { opacity: 1, x: 0, transition: { duration: 0.5 } },
                  }}
                  className="flex items-center justify-between py-4 group"
                  data-testid={`distance-${d.place.replace(/\s+/g, "-").toLowerCase()}`}
                >
                  <div className="flex items-center gap-3">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#D4AF37] group-hover:scale-150 transition-transform" />
                    <span className="text-sm md:text-base text-[#F8F6F0] font-light">{d.place}</span>
                  </div>
                  <span className="font-mono text-xs md:text-sm text-[#D4AF37] tracking-wider">@ {d.dist}</span>
                </motion.li>
              ))}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>
  );
};